import { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";
// import "./table.css";

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  // 🔹 FETCH USERS (ADMIN ONLY)
  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        alert("Please login as admin");
        return;
      }

      const res = await axios.get(
        "http://localhost:5000/api/users",
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      // backend returns { users: [] }
      setCustomers(res.data.users || []);
    } catch (error) {
      alert("Failed to load users (admin only)");
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredCustomers = customers.filter((u) =>
    `${u.name} ${u.email}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <div className="admin-body">
      <Topbar />
      <Sidebar />

      <main className="admin-main">
        <div className="dashboard-header">
          <h1 style={{ color: "#374151" }}>Customers</h1>
          <input
            placeholder="Search name or email"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <section className="table-card">
          {loading ? (
            <p style={{ padding: 20 }}>Loading users...</p>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Created</th>
                </tr>
              </thead>

              <tbody>
                {filteredCustomers.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center" }}>
                      No users found
                    </td>
                  </tr>
                ) : (
                  filteredCustomers.map((user) => (
                    <tr key={user._id}>
                      <td>{user._id.slice(-6)}</td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>
                        {new Date(user.createdAt).toLocaleDateString()}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
}
